function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.88878 18.1413V16.0009C9.88878 15.4545 10.3584 15.0116 10.9378 15.0116H13.0556C13.3338 15.0116 13.6006 15.1158 13.7974 15.3014C13.9941 15.4869 14.1046 15.7385 14.1046 16.0009V18.1413C14.1029 18.3685 14.1973 18.5869 14.367 18.7481C14.5367 18.9093 14.7676 19 15.0085 19H16.4533C17.1282 19.0016 17.7759 18.75 18.2537 18.3006C18.7315 17.8511 19 17.2409 19 16.6045V10.5068C19 9.99272 18.7584 9.50509 18.3402 9.17527L13.4251 5.47311C12.5701 4.82399 11.345 4.84495 10.5156 5.52289L5.71254 9.17527C5.27465 9.49537 5.01293 9.98445 5 10.5068V16.5983C5 17.9247 6.14018 19 7.54665 19H8.95853C9.4588 19 9.86537 18.6194 9.86899 18.1476L9.88878 18.1413Z",
  fill: "#9E9E9E"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.d1a17e3e.svg";
export { ForwardRef as ReactComponent };